<template>
	<div id="ClubWorkPlan">
		<index>
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>德育</el-breadcrumb-item>
				<el-breadcrumb-item><a style="color: #000000;">社团管理</a></el-breadcrumb-item>
			</el-breadcrumb>
			<div class="nav-tab-bar-box u-f-item u-f-jsb">
				<div class="nav-tab-bar u-f-item">
					<div
						class="font_14 nav-tab-item"
						@click="twacherTap(index)"
						:class="index == teacherIndex ? 'active' : ''"
						v-for="(item, index) in teacherMeun"
						:key="index"
					>
						{{ item.name }}
					</div>
				</div>
				
			</div>
			<div class="content">
				<div class="suguan">
					<div class="title u-f-item u-f-jsb">
						<div>
							共{{ total }}条数据
						</div>
						<div class="u-f-item">
							<el-button size='small' @click="add">新增申请</el-button>
						</div>
					</div>
					<el-table
						:data="list"
						height="93%"
						style="width: 100%;border: 1px solid #EEEEEE;"
					>
						<el-table-column type="index" label="序号" align="center"></el-table-column>
						<el-table-column label="社团名称" align="center" prop="club_name"></el-table-column>
						<el-table-column label="活动人数" align="center" prop="activities_number"></el-table-column>
						<el-table-column prop="teacher" label="指导老师" align="center"></el-table-column>
						<el-table-column label="活动时间" prop="activity_time" align="center"></el-table-column>
						<el-table-column label="活动内容" prop="content" align="center"></el-table-column>
						<el-table-column label="活动目标" prop="target" align="center"></el-table-column>
						<el-table-column label="出席人员" prop="present_members" align="center"></el-table-column>
						<el-table-column label="活动申请人" prop="activity_applicant" align="center"></el-table-column>
						<el-table-column label="操作" width="100" align="center">
							<template  slot-scope="scope">
								<el-button  type="text" size="small" @click="edit(scope.row)">编辑</el-button>
								<el-button  type="text" @click="deltel(scope.row.id)" size="small">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="u-f-right" style="padding: 15px 0;">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page.sync="page"
							:page-size="limit"
							layout="total, prev, pager, next"
							:total="total"
						></el-pagination>
					</div>
				</div>
			</div>
			
			<!-- 添加指导计划 -->
			<el-dialog title="授课申请" :visible.sync="addShow" width="500px" :before-close="handleClose">
				<div class="edit-box">
					<div class="u-f-item input-box">
						<div class="input-lebal" style="text-align: right;width: 80px;">
							<span>*</span>
							社团名称
						</div>
						<el-input v-model="club_name" placeholder="请输入社团名称" style="width: 70%;"></el-input>
					</div>
				</div>
				<div class="edit-box">
					<div class="u-f-item input-box">
						<div class="input-lebal" style="text-align: right;width: 80px;">
							<span>*</span>
							活动人数
						</div>
						<el-input v-model="activities_number" placeholder="请输入活动人数" style="width: 70%;"></el-input>
					</div>
				</div>
				<div class="edit-box">
					<div class="u-f-item input-box">
						<div class="input-lebal" style="text-align: right;width: 80px;">
							<span>*</span>
							指导老师
						</div>
						<el-input v-model="teacher" placeholder="请输入指导老师姓名" style="width: 70%;"></el-input>
					</div>
				</div>
				<div class="edit-box">
					<div class="u-f-item input-box">
						<div class="input-lebal" style="text-align: right;width: 80px;">
							<span>*</span>
							活动申请人
						</div>
						<el-input v-model="activity_applicant" placeholder="请输入活动申请人" style="width: 70%;"></el-input>
					</div>
				</div>
				<div class="edit-box">
					<div class="u-f-item input-box">
						<div class="input-lebal" style="text-align: right;width: 80px;">
							<span>*</span>
							活动时间
						</div>
						<el-date-picker  value-format="yyyy-MM-dd H:mm" v-model="activity_time" type="datetime" placeholder="选择活动时间"  style="width: 70%;"></el-date-picker>
					</div>
				</div>
				<div class="edit-box">
					<div class="u-f input-box">
						<div class="input-lebal" style="text-align: right;width: 80px;margin-top: 5px;">
							<span>*</span>
							活动内容
						</div>
						<el-input type="textarea" v-model="content" placeholder="请输入活动内容" style="width: 70%;"></el-input>
					</div>
				</div>
				<div class="edit-box">
					<div class="u-f-item input-box">
						<div class="input-lebal" style="text-align: right;width: 80px;">
							<span>*</span>
							活动目标
						</div>
						<el-input v-model="target" placeholder="请输入活动目标" style="width: 70%;"></el-input>
					</div>
				</div>
				<div class="edit-box">
					<div class="u-f-item input-box">
						<div class="input-lebal" style="text-align: right;width: 80px;">
							<span>*</span>
							出席人员
						</div>
						<el-input v-model="present_members" placeholder="请输入出席人员" style="width: 70%;"></el-input>
					</div>
				</div>
				<span slot="footer" class="dialog-footer u-f-item u-f-jsb">
					<el-button @click="colseShow" size="small">取 消</el-button>
					<el-button type="primary" size="small" @click="submit">确 定</el-button>
				</span>
			</el-dialog>
		</index>
	</div>
</template>

<script>
import index from '@/components/common/index.vue';
export default {
	components: {
		index
	},
	data() {
		return {
			teacherMeun: [
				{ name: '社团指导工作计划',id:1},
				{ name: '授课申请',id:2},
				{ name: '经费收支',id:3}
			],
			teacherIndex: 1,
			page:1,
			limit:10,
			list:[],
			total:0,
			addShow:false,
			club_name:'',
			teacher:'',
			activities_number:'',
			activity_applicant:'',
			activity_time:'',
			present_members:'',
			content:'',
			target:'',
			type:1,
			edit_id:''
		};
	},
	mounted() {
		this.getClubWorkPlanList()
	},
	methods: {
		edit(item){
			this.type= 2;
			this.club_name = item.club_name;
			this.teacher = item.teacher;
			this.activities_number = item.activities_number;
			this.activity_applicant = item.activity_applicant;
			this.activity_time = item.activity_time;
			this.present_members = item.present_members;
			this.content = item.content;
			this.target = item.target;
			this.edit_id = item.id;
			this.addShow = true;
		},
		add(){
			this.type= 1;
			this.addShow = true;
		},
		twacherTap(index){
			if(index==0){
				this.$router.push('/ClubWorkPlan')
			}else if(index==1){
				this.$router.push('/schooling')
			}else if(index==2){
				this.$router.push('/expenditure')
			}
		},
		handleClose(done){
			done()
		},
		getClubWorkPlanList(){
			this.$api.station.getSchoolingList({page:this.page,limit:this.limit}).then(res=>{
				if(res.data.code==1){
					this.total = res.data.data.total;
					this.list = res.data.data.rows;
				}
			})
		},
		colseShow(){
			this.init()
			this.addShow = false;
		},
		init(){
			this.club_name = '';
			this.teacher = '';
			this.activities_number = '';
			this.activity_applicant = '';
			this.activity_time = '';
			this.present_members = '';
			this.content = '';
			this.target = '';
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			this.page = val;
			this.getClubWorkPlanList()
		},
		submit(){
			if(this.type==1){
				this.addSchooling()
			}else{
				this.editSchooling()
			}
		},
		addSchooling(){
			if(!this.club_name){this.$message.error('请输入社团名称')}
			if(!this.activities_number){this.$message.error('请输入活动人数')}
			if(!this.teacher){this.$message.error('请输入指导老师姓名')}
			if(!this.activity_applicant){this.$message.error('请输入活动申请人')}
			if(!this.activity_time){this.$message.error('请选择活动时间')}
			if(!this.content){this.$message.error('请输入活动内容')}
			if(!this.target){this.$message.error('请输入活动目标')}
			if(!this.present_members){this.$message.error('请输入出席人员')}
			this.$api.station.addSchooling({
				club_name:this.club_name,
				activities_number:this.activities_number,
				teacher:this.teacher,
				activity_applicant:this.activity_applicant,
				activity_time:this.activity_time,
				content:this.content,
				target:this.target,
				present_members:this.present_members
			}).then(res=>{
				if(res.data.code==1){
					this.$message.success('添加成功')
					this.getClubWorkPlanList();
					this.init()
					this.addShow = false;
				}else{
					this.$message.error(res.data.msg)
				}
			})
		},
		editSchooling(){
			if(!this.club_name){this.$message.error('请输入社团名称')}
			if(!this.activities_number){this.$message.error('请输入活动人数')}
			if(!this.teacher){this.$message.error('请输入指导老师姓名')}
			if(!this.activity_applicant){this.$message.error('请输入活动申请人')}
			if(!this.activity_time){this.$message.error('请选择活动时间')}
			if(!this.content){this.$message.error('请输入活动内容')}
			if(!this.target){this.$message.error('请输入活动目标')}
			if(!this.present_members){this.$message.error('请输入出席人员')}
			this.$api.station.editSchooling({
				club_name:this.club_name,
				activities_number:this.activities_number,
				teacher:this.teacher,
				activity_applicant:this.activity_applicant,
				activity_time:this.activity_time,
				content:this.content,
				target:this.target,
				present_members:this.present_members,
				id:this.edit_id
			}).then(res=>{
				if(res.data.code==1){
					this.$message.success('修改成功')
					this.getClubWorkPlanList();
					this.init()
					this.addShow = false;
				}else{
					this.$message.error(res.data.msg)
				}
			})
		},
		deltel(id){
			this.$confirm('确定要删除？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消'
			}).then(() => {
				this.$api.station.delSchooling({
					id:id
				}).then(res=>{
					if(res.data.code==1){
						this.$message.success('删除成功')
						this.getClubWorkPlanList();
					}else{
						this.$message.error(res.data.msg)
					}
				})
			});
		}
	}
};
</script>

<style lang="scss">
#ClubWorkPlan {
	.nav-tab-bar-box {
		background-color: #ffffff;
		padding: 15px;
		margin-top: 1.04vw;
		.nav-tab-bar {
			.nav-tab-item {
				color: #6e7a87;
				padding: 0 0.78125vw;
				border-right: 1px solid #f3f3f3;
				cursor: pointer;
				-webkit-touch-callout: none;
				-webkit-user-select: none;
				-khtml-user-select: none;
				-moz-user-select: none;
				-ms-user-select: none;
				user-select: none;
			}
			&div:last-child {
				border-right: none;
			}
			.active {
				font-size: 0.833vw;
				color: #63acff;
				position: relative;
				font-weight: bold;
			}
			.active::after {
				position: absolute;
				content: '';
				height: 2px;
				left: 0.78125vw;
				right: 0.78125vw;
				background-color: #63acff;
				bottom: -0.78125vw;
			}
		}
	}
	.head {
		background-color: #ffffff;
		padding: 10px 30px;
		margin-top: 15px;
		.span {
			margin-right: 10px;
			background-color: #f9f9f9;
			color: #8d9da6;
			padding: 3px 10px;
		}
	}
	.content {
		margin-top: 20px;
		background-color: #ffffff;
		height: 78vh;
		.left {
			border-right: 1px solid #eeeeee;
			height: 78vh;
			min-width: 300px;
			.add {
				background-color: #f8f8f8;
				padding: 10px 0;
				font-size: 24px;
				color: #8d9da6;
				cursor: pointer;
			}
			.add:hover {
				color: #007aff;
			}
			.building-list {
				padding: 25px;
				height: 74vh;
				overflow-y: auto;
				.item {
					padding: 0 15px;
					height: 40px;
					line-height: 40px;
					margin-top: 15px;
					background-color: #f8f8f8;
					.el-icon-caret-right,
					.el-icon-caret-bottom {
						color: #a4a4a4;
						margin-right: 5px;
						font-size: 16px;
					}
					.el-checkbox {
						display: block;
					}
					.btn {
						i {
							background-color: #e8eaec;
							color: #a4a4a4;
							width: 25px;
							height: 25px;
							margin-left: 10px;
							border-radius: 50%;
						}
						i:hover {
							color: red;
						}
					}
				}
				.floor-list {
					background-color: #f8f8f8;
					border-top: 1px solid #eeeeee;
					padding: 0 15px 15px 30px;
					.floor-item {
						background-color: #f1f1f1;
						padding: 0 15px 0 25px;
						color: #4c5559;
						height: 40px;
						line-height: 40px;
						margin-top: 15px;
						.btn {
							i {
								background-color: #ffffff;
								color: #a4a4a4;
								width: 25px;
								height: 25px;
								margin-left: 10px;
								border-radius: 50%;
							}
							i:hover {
								color: red;
							}
						}
					}
					.active {
						background-color: #e4f1ff;
						color: #007aff;
					}
				}
			}
		}
		.right {
			height: 68vh;
			width: 100%;
			padding: 25px 50px;
			.title {
				padding: 0 0 15px 0;
			}
		}
		.suguan{
			padding: 15px 50px 15px 50px;
			height: 70vh;
			.title {
				padding: 0 0 15px 0;
			}
		}
	}

	.el-dialog__header {
		border-bottom: 1px solid #eeeeee;
		padding: 10px 20px;
		.el-dialog__title {
			font-size: 16px;
		}
	}
	.el-dialog__body {
		padding: 0 20px 35px 20px;
		overflow-y: auto;
		height: 500px;
		.edit-box {
			.input-box {
				margin-top: 35px;
				padding-left: 15px;
				.input-lebal {
					color: #aeb5b8;
					margin-right: 10px;
					span {
						color: #ff7a65;
						margin-right: 3px;
					}
				}
				.el-icon-remove-outline {
					font-size: 1.5625vw;
					color: #d7d9db;
					margin-left: 10px;
				}
				.input-item{
					.el-select .el-input.is-disabled .el-input__inner {
						cursor: default;
					}
					.el-input.is-disabled .el-input__inner {
						background-color: #ffffff;
						cursor: default;
					}
					.el-input__prefix,
					.el-input__suffix {
						display: none;
					}
				}
			}
			.avatar-uploader .el-upload {
				border: 1px dashed #d9d9d9;
				border-radius: 6px;
				cursor: pointer;
				position: relative;
				overflow: hidden;
			}
			.avatar-uploader .el-upload:hover {
				border-color: #409eff;
			}
			.avatar-uploader-icon {
				font-size: 28px;
				color: #8c939d;
				width: 90px;
				height: 90px;
				line-height: 90px;
				text-align: center;
			}
			.avatar {
				width: 90px;
				height: 90px;
				display: block;
			}
		}
	}
	.el-dialog__footer {
		padding: 15px 20px 15px;
		box-shadow: 0px -5px 10px -5px #eeeeee;
	}

	.el-table__column-filter-trigger {
		.el-icon-arrow-down:before {
			content: '\E790';
			font-size: 16px;
		}
	}
}

.selectShow {
	.el-dialog__header {
		border-bottom: 1px solid #eeeeee;
		padding: 10px 20px;
		.el-dialog__title {
			font-size: 16px;
		}
	}
	.el-dialog__body {
		padding: 0;
		.user-list-box {
			.user-list-head {
				padding: 10px 20px;
				border-bottom: 1px solid #eeeeee;
				.user-type-list {
					.user-type-item {
						color: #8d9da6;
						cursor: pointer;
					}
					.active {
						color: #007aff;
						position: relative;
					}
					.active::after {
						position: absolute;
						width: 25px;
						height: 2px;
						background-color: #007aff;
						content: '';
						bottom: -5px;
						left: 0;
					}
					span {
						color: #cccccc;
						margin: 0 8px;
					}
				}
			}
			.user-list-content {
				height: 40vh;
				.left {
					height: 98%;
					overflow-y: auto;
					border-right: 1px solid #eeeeee;
					padding-top: 5px;
					.left-item {
						padding: 0 20px;
						height: 40px;
						line-height: 40px;
						color: #a4a4a4;
						cursor: pointer;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}
					.active {
						background-color: #e4f1ff;
						color: #2d8cf0;
						position: relative;
					}
					.active:after {
						position: absolute;
						top: 0;
						bottom: 0;
						right: 0;
						width: 2px;
						content: '';
						background-color: #2d8cf0;
					}
				}
				.right {
					height: 37vh;
					padding: 10px 25px;
					overflow-y: auto;
					.list {
						display: flex;
						flex-wrap: wrap;
						.item {
							cursor: pointer;
							padding: 5px 15px;
							border-radius: 3px;
							background-color: #f3f3f3;
							margin-right: 10px;
							margin-bottom: 10px;
						}
						.active {
							background-color: #e4f1ff;
							color: #2d8cf0;
						}
					}
				}
			}
		}
	}
	.dialog-title {
		padding: 10px 0 5px 0;
	}
	.el-dialog__footer {
		padding: 15px 20px 15px;
		box-shadow: 0px -5px 10px -5px #eeeeee;
	}
}
.el_option {
	display: none !important;
}
</style>
